<template>
    <form
        :class="formClass"
        autocomplete="off"
        @submit.prevent="$emit('submit')"
    >
        <div class="flex flex-col lg:flex-row">
            <slot name="inputs">
                <!-- SLOT FOR INPUTS -->
            </slot>
            <slot name="buttons">
                <!-- SLOT FOR SUBMIT, CLOSE BUTTONS -->
            </slot>
        </div>
    </form>
</template>

<script>
export default {
    emits: ['submit', 'close'],
    components: {},
    props: {
        formClass: {
            type: String,
            default:
                'search-form w-full w-full @2xl:h-14 p-2 bg-white rounded-xl shadow gap-2.5 relative',
        },
    },
    setup() {
        return {};
    },
};
</script>
